import { Component } from '@angular/core';
import { SharedModule } from '../../../modules/shared/shared.module';
import { AppService, LoginComponent, LoyaltyService, PaymentData, UserLoyaltyResult, UserService } from 'briteatlib';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Auth } from '@angular/fire/auth';
import { User } from 'briteatlib';
import { MenuItem } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { InputNumberModule } from 'primeng/inputnumber';
import { PaymentLogosComponent } from '../../general/payment-logos/payment-logos.component';
import { CurrencyPipe } from '@angular/common';
import { InputGroupModule } from 'primeng/inputgroup';

@Component({
  selector: 'brt-user-status',
  standalone: true,
  imports: [SharedModule, LoginComponent, InputNumberModule, PaymentLogosComponent, InputGroupModule],
  providers: [CurrencyPipe],
  templateUrl: './user-status.component.html',
  styleUrl: './user-status.component.scss'
})
export class UserStatusComponent {
  user: User;
  menuItems: MenuItem[];
  addBalanceDialog: boolean;

  constructor(private auth: Auth, private userService: UserService, appService: AppService,
    private currency: CurrencyPipe, loyaltyService: LoyaltyService) {
    combineLatest([appService.activeBusiness$, userService.current$, loyaltyService.userLoyalty$])
      .pipe(takeUntilDestroyed()).subscribe(([business, user, loyalty]) => this.load(business, user, loyalty));
  }

  private load(business: any, user: User, loyalty: UserLoyaltyResult): void {
    this.user = user;
    if (!user) return;
    this.menuItems = [
      // {
      //   label: 'My profile',
      //   icon: 'pi pi-user',
      //   routerLink: '/profile',
      // },
      // {
      //   label: 'My orders',
      //   icon: 'pi pi-shopping-cart',
      //   routerLink: '/order',
      // },
      // {
      //   label: 'My favorites',
      //   icon: 'pi pi-heart',
      //   routerLink: '/favorite',
      // },
      {
        label: 'Balance [' + this.currency.transform(user.Balance, 'GBP', 'symbol') + ']',
        icon: 'pi pi-money-bill',
        command: () => this.addBalanceDialog = true
      },
      loyalty?.MainCredit?.Credit > 0 ? {
        label: 'Briteat Credit\n[' + this.currency.transform(loyalty.MainCredit.Credit, 'GBP', 'symbol') + ']',
        icon: 'pi pi-credit-card text-danger',
      } : null,
      loyalty?.BusinessCredit?.Credit > 0 ? {
        label: 'Restaurant Credit\n[' + this.currency.transform(loyalty.BusinessCredit.Credit, 'GBP', 'symbol') + ']',
        icon: 'pi pi-credit-card tw-text-blue-500',
      } : null,
      {
        label: 'Loyalty Points\n[' + loyalty.Balance + ']',
        icon: 'pi pi-star tw-text-yellow-500',
        routerLink: '/rewards',
      },
      {
        label: 'Logout',
        icon: 'pi pi-sign-out',
        command: async () => {
          await this.signOut();
        }
      },
    ].filter(_ => !!_);
  }

  signOut() {
    this.auth.signOut();
    window.location.reload();
  }

  gettingHash: boolean;
  extendedHash: PaymentData;
  balanceAmount: number = 10;
  async getExtendedHash() {
    this.gettingHash = true;
    try { this.extendedHash = await this.userService.getPaymentData('balance', this.balanceAmount); }
    finally { this.gettingHash = false; }
  }
}
